import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import EditButtons from 'scoreboard/components/edit/edit-buttons'
import InitiativesDisplayHeader from '../initiatives-display-header'
import tabs from '../initiatives-tabs.hbs'
import formHelper from 'scoreboard/components/form-helper'
import template from './initiatives-edit.hbs'
import dropdown from 'scoreboard/components/dropdown'
import InitiativesAdvancedForm from './initiatives-advanced-form'
import appDisplay from 'scoreboard/components/app-display'
import DateInput from 'scoreboard/components/date-input'
import i18n from 'scoreboard/components/i18n'
import FormView from 'scoreboard/components/form-view'
import MarkedField from 'scoreboard/components/marked-field'
import positiveNumberValidator from 'scoreboard/components/validators/positive-number-validator'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import Initiative from 'scoreboard/initiatives/initiative'
import conductor from 'scoreboard/components/conductor'
import currency from 'scoreboard/components/currency'
import autofocus from 'scoreboard/polyfills/autofocus'
import selects from 'scoreboard/components/selects'
import PrincipalPanel from 'scoreboard/components/principal-panel'
import * as dateRangeValidatorFactory from 'scoreboard/components/validators/date-range-validator-factory'
import InitiativeArchiveActions from '../initiatives-archive-actions'
import initiativeArchiveButtons from '../initiatives-archive-buttons.hbs'
import AssignmentAlerts from 'scoreboard/components/assignment-alerts'
import initiativesPasteAllowed from './initiatives-paste-allowed'
import permissions from 'scoreboard/components/permissions'
import ImportOptions from 'scoreboard/components/import-options'
import DataType from 'scoreboard/datasets/model/data-type'
const { CURRENCY } = DataType
import { triggerAddOrEdit } from 'scoreboard/components/domain-object-events'
import { isV6 } from 'scoreboard/components/version'

var EditInitiativeForm = Backbone.View.extend({

	// this.model is an Initiative

	tagName: 'form',

	className: 'table-hack display-layout initiatives-edit',

	events: {
		'click .cancel': 'cancel',
		'click .advanced': 'advanced',
		'click .initiatives-archive .button': '_archiveActionClick',
		'change .currency-code': 'changeCurrency',
		'change .type': 'changeType'
	},

	initialize: function() {
		// the attributes that will be saved if the user clicks save
		this.attributes = {}
		// issue #10117 make sure we start with the advanced form values
		// so they will be persisted even if the advanced form is not opened
		this.populateAttributesWithAdvancedOptions()

		if (this.model.isNew()) {
			this.model.set('label', i18n.get('initiatives.newInitiative'))
		}

		this.formView = new FormView({
			toggleCancel: true,
			el: this.el,
			submit: this.submit.bind(this),
			// #43166 creating a new initiative shouldn't require any additional
			// input to save
			allowCleanSubmission: this.model.isNew()
		})
		this.formView.on('change', this._change.bind(this))
		_.bindAll(this, 'setTypeVisibility')
	},

	gardener: function() {
		return _.get(_.invoke(appDisplay, 'navView'), 'gardener') // test-friendly
	},

	tree: function() {
		return _.get(this.gardener(), 'tree')
	},

	populateAttributesWithAdvancedOptions: function () {
		_.extend(this.attributes, _.pick(this.model.attributes, 'goalFunction', 'expenditures', 'tags'))
	},

	_change: function() {
		// we have to keep track of the attributes this way because on change,
		// the listener in the nav pane will populate the parentId and index
		// properties on the attributes and we need to send those to the server
		_.extend(this.attributes, formHelper.readFromDom(this.el))
		this.assignmentAlerts.activate()
		this.trigger('change', this.attributes)
	},

	render: function () {
		this.removeChildren()
		// setup header
		var heading = this.model.isNew() ? i18n.get('initiatives.create') :
			this.model.get('label')

		let id = this.previousId || this.model.id || this.model.get('relativeId')
		this.header = new InitiativesDisplayHeader({
			heading: heading,
			model: this.model,
			subsection: 'edit',
			// TODO: Remove when V5 is no longer supported
			// Only remove the isV6() check.
			tabs:  this.model.isNew() && isV6() ? '' : tabs({
				id,
				section: 'initiatives'
			}),
			importOptions: ImportOptions.forInitiativeItem(this.model)
		}).render()

		// setup buttons
		this.editButtons = new EditButtons({
			model: this.model,
			pasteAllowed: initiativesPasteAllowed,
			alertNotificationPrompt: {
				delete: true
			}
		}).render()

		var hasMultipleCurrencies = _.size(currency.all()) > 1

		// render to the DOM
		var context = {
			hasMultipleCurrencies: hasMultipleCurrencies
		}
		this.$el.empty().append(this.header.el, template(context))
		this.$('.edit-buttons-container').append(this.editButtons.$el.addClass('edit-buttons-bottom'))
		if (hasMultipleCurrencies) {
			dropdown.currency(this.$('.currency-code'))
		} else {
			this.$('.initiative-currency').remove()
		}

		this.archiveActions = new InitiativeArchiveActions({
			el: this.$('.banner-archive'),
			model: this.model
		})
		this.model.on('change:archiveDate', this._renderArchiveActionButtons.bind(this))

		// add assigned users/groups panel
		this.renderPrincipalPanel()

		formHelper.writeToDom(this.model, this.el)

		// setup our fancy input controls
		this.startDate = new DateInput({ el: this.$('.start-date') }).render()

		this.endDate = new DateInput({
			el: this.$('.end-date'),
			validator: dateRangeValidatorFactory.afterDateInput(
				DateInput.dateFormat(), this.startDate, 'initiatives.startDate')
		}).render()

		this.startDate.on('validated', () => this.endDate.validate())

		this.budget = new MarkedField({
			el: this.$('.budget'),
			evaluator: numericEvaluator,
			validator: positiveNumberValidator,
			dataType: CURRENCY,
			currencyCode: this.model.get('currencyCode')
		}).render()
		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()

		this.formView.start({
			isNew: this.model.isNew(),
			primaryButtonEl: this.$('.save')
		})
		selects(this.el.querySelectorAll('select'))

		appDisplay.navView() && appDisplay.navView()._onceTreeLoaded(() => this.setTypeVisibility())
		this.changeType()

		this.archiveActions.render()
		// Insert archive buttons if they dont exist
		const orgId = this.model.get('organizationId')
		if (permissions.archiveInitiatives(orgId) &&
			this.$('.initiatives-archive').length == 0) {
			this.$('.delete-container').after(initiativeArchiveButtons())
			this._renderArchiveActionButtons()
		}

		this.assignmentAlerts = new AssignmentAlerts({
			label: i18n.get('common.notifyAssignedUsers.edit'),
			assignmentView: this.$('.display-pane-body .scroll-container'),
			parent: this.$('.edit-buttons-container')
		}).render()

		this.$('[name=label]').select()

		return this
	},

	// creates and renders the assignees panel
	renderPrincipalPanel: function() {
		const {organizationId} = this.model.attributes
		this.principalPanel = new PrincipalPanel({
			url: `api/organizations/${organizationId}/potential-assignees`,
			headingKey: 'initiatives.assignedUsersAndGroups',
			placeholderKey: 'admin.group.addUserGroup',
			currentPrincipals: this.model.get('assignees')
		})
		this.principalPanel.on('change', () => {
			this.assignmentAlerts.activate()
			this.formView.change()
		})
		this.$('.assignees').html(this.principalPanel.el)
		this.principalPanel.render()
	},

	changeCurrency: function() {
		this.budget.mark({ currencyCode: this.$('.currency-code').val() })
	},

	setTypeVisibility() {
		// If user drops a child into/out of the current node we need to check this again
		this.tree().once('dndmove', this.setTypeVisibility)

		const {id, type} = this.model.attributes

		// #26156 - If the parent is a task, initiative must be suppressed
		if ('task' === type) { // type is the type of the relative node (the parent of the selection)
			this.$('option[value=initiative]').addClass('is-not-displayed')
		}

		if (id) { // Rules for existing nodes only
			const children = this.tree().children(this.tree().get(id))
			// #18242 Nodes with children must not be changed to milestones
			this.$('option[value=milestone]').toggleClass('is-not-displayed', !_.isEmpty(children))
			// #21557 Nodes with child initiatives can not be changed to tasks
			this.$('option[value=task]').toggleClass('is-not-displayed', _.some(children, {type: 'initiative'}))
		}
	},

	changeType: function() {
		var type = this.$('[name=type]').val()
		var milestone = type === 'milestone'

		if (!_.isNil(this.model.id)) {
			this.gardener()._onceTreeLoaded(() => {
				// #21682 - Make sure tree node has the type so DnD follows droppable rules correctly
				const node = this.tree().get(this.model.id)
				node.type = type
				this.tree().edit(node)
			})
		}

		// #18804 If user initially had a start date before switching type to a milestone,
		// clear out the start date and re-validate the end-date
		if (milestone) {
			this.$('.start-date').val('')
			this.endDate.validate()
		}
		this.$('.initiative-start-date').toggleClass('is-not-displayed', milestone)
		this.$('.initiative-end-date').toggleClass('milestone-end-date', milestone)
	},

	cancel: function() {
		this._advancedData = null
		if (this.model.isNew()) {
			if (conductor.id()) {
				conductor.edit()
			} else {
				var url = 'organizations/' + this.model.get('organizationId') + '/initiatives'
				conductor.navigate(url, { trigger: true })
			}
		} else {
			// need to render again so the assignees panel is correct
			this.render()
		}
	},

	submit: function(e) {
		var data = _.extend(this.attributes, formHelper.readFromDom(this.el),
			this._advancedData)
		data.assignees = this.principalPanel.getPrincipals()

		var event = this.model.isNew() ? 'add' : 'edit'

		return this.model.save(data, {
			patch: this.model.isNew() ? false : true,
			success: function(model) {
				this.previousId = model.id
				this.attributes = {}
				delete this._advancedData

				if (event === 'add') {
					// right away display a form to create another initiative
					var preserved = [ 'type', 'parentId', 'organizationId', 'currencyCode', 'goalFunction' ]
					this.model = new Initiative(model.pick(preserved))
					this.model.set('label', i18n.get('initiatives.newInitiative'))

					formHelper.writeToDom(this.model, this.el, true)
					this.renderPrincipalPanel()
					this.render()
					autofocus(this.el)
					this.$('h1').text(i18n.get('initiatives.create'))
				} else {
					// #20850 make sure we have the values for the advanced options dialog
					// when repeatedly editing an initiative and staying on the edit page
					this.populateAttributesWithAdvancedOptions()
					this.$('.move, .copy, .delete').prop('disabled', false)
				}

				this.formView.start({
					isNew: this.model.isNew(),
					instadone: true,
					primaryButtonEl: this.$('.save')
				})
				this.trigger('save', model, this.model)
				triggerAddOrEdit(event, model)
			}.bind(this),
			error: function(model, response, options) {
				this.formView.error(response)
			}.bind(this)
		})
	},

	advanced: function() {
		var model = this.model
		if (this._advancedData) {
			model = new Initiative(this._advancedData)
		}
		appDisplay.dialog($.get('api/tags'), globalTags => {
			const form = new InitiativesAdvancedForm({
				model,
				globalTags,
				selectedType:  this.$('[name=type]').val()
			})
			form.once('done', data => {
				this.formView.change()
				this._advancedData = data
			})
			return form
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.removeChildren()
		this.formView.remove()
		this.tree() && this.tree().removeListener('dndmove', this.setTypeVisibility)
	},

	removeChildren: function() {
		this.formView.stopListening()
		_.invokeMap([this.header, this.editButtons,
			this.startDate, this.endDate, this.budget, this.labelField,
			this.principalPanel, this.archiveActions,
			this.assignmentAlerts], 'remove')
		_.invokeMap(this._markedFields, 'remove')
	},

	_archiveActionClick: function() {
		this.archiveActions.click()
		this._renderArchiveActionButtons()
	},

	_renderArchiveActionButtons: function() {
		var complete = !!this.model.get('aggregatedCompletionDate')
		this.$('.button.archive, .button.unarchive').toggleClass('is-not-displayed', !complete)
		if (complete) {
			var archived = !this.archiveActions.isArchived()
			this.$('.button.archive').toggleClass('is-not-displayed', !archived)
			this.$('.button.unarchive').toggleClass('is-not-displayed', archived)
		}
	}

})

export default EditInitiativeForm
EditInitiativeForm.__filename__ = 'initiatives/edit/initiatives-edit.js'
